import { render } from "./onboarding.vue?vue&type=template&id=54f6f42a&scoped=true"
import script from "./onboarding.vue?vue&type=script&lang=js"
export * from "./onboarding.vue?vue&type=script&lang=js"

import "./onboarding.vue?vue&type=style&index=0&id=54f6f42a&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f6f42a"],['__file',"src/components/home/onboarding.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54f6f42a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54f6f42a', __exports__)) {
    api.reload('54f6f42a', __exports__)
  }
  
  module.hot.accept("./onboarding.vue?vue&type=template&id=54f6f42a&scoped=true", () => {
    api.rerender('54f6f42a', render)
  })

}


export default __exports__